import type { State } from '../../reducers/types.tsx';

export const getAccountId = (state: State): string | null | undefined =>
	state.appProps.atlassianAccountId;
